import axios from "axios";
import { firebaseFunctionsUrl } from "../Helpers/FirebaseEnvironments";

const extractJson = (content: string) => {
  try {
    if (content.trim().startsWith("{") || content.trim().startsWith("[")) {
      try {
        const jsonData = JSON.parse(content);
        return jsonData;
      } catch (error) {
        console.error("Error parsing JSON:", error, content);
        return null;
      }
    } else {
      console.error(
        "Invalid JSON format or content appears to be HTML:",
        content
      );
      return "Invalid JSON format or content appears to be HTML: " + content;
    }
  } catch (error) {
    console.error("Error parsing JSON:", error, content);
    return null;
  }
};

export const getCVRdata = async (criteria: string) => {
  try {
    if (criteria.trim()) {
      axios.defaults.withCredentials = true;
      const res = await axios.post(firebaseFunctionsUrl("cvr"), {
        query: { criteria: criteria },
      });
      const result = res.data;

      if (result) {
        return result;
      } else {
        return "No completion content found.";
      }
    } else {
      return "Please enter a topic before generating output.";
    }
  } catch (error) {
    return "Error generating output: " + (error as Error).message;
  } finally {
  }
};

export const getCVRinfo = async (criteria: string) => {
  try {
    if (criteria.trim()) {
      axios.defaults.withCredentials = true;
      const apiUrl =
        import.meta.env.VITE_ENV === "DEV"
          ? `https://cvrapi.dk/api?search=${criteria}&country=dk`
          : `https://cvrapi.dk/api?search=${criteria}&country=dk`;
      const res = await axios.get(apiUrl);
      const result = JSON.stringify(res.data);
      if (result) {
        // console.info("Response from CVR API:", result);
        const formattedResult = formatCompanyInfo(JSON.parse(result));
        return formattedResult;
      } else {
        return "Web address not found.";
      }
    } else {
      return "Please enter a topic before generating output.";
    }
  } catch (error) {
    return "Error generating output: " + (error as Error).message;
  } finally {
  }
};

const formatCompanyInfo = (data: any) => {
  return `
    <div class="company-info">
      <h2>Company Information</h2>
      <ul>
        <li><strong>VAT:</strong> ${data.vat}</li>
        <li><strong>Name:</strong> ${data.name}</li>
        <li><strong>Address:</strong> ${data.address}</li>
        <li><strong>Zip Code:</strong> ${data.zipcode}</li>
        <li><strong>City:</strong> ${data.city}</li>
        <li><strong>Phone:</strong> ${data.phone}</li>
        <li><strong>Email:</strong> ${data.email}</li>
        <li><strong>Start Date:</strong> ${data.startdate}</li>
        <li><strong>Employees:</strong> ${data.employees}</li>
        <li><strong>Industry Code:</strong> ${data.industrycode}</li>
        <li><strong>Industry Description:</strong> ${data.industrydesc}</li>
        <li><strong>Company Code:</strong> ${data.companycode}</li>
        <li><strong>Company Description:</strong> ${data.companydesc}</li>
      </ul>
      <h3>Owners</h3>
      <ul>
        ${
          data.owners && data.owners.length > 0
            ? data.owners.map((owner: any) => `<li>${owner.name}</li>`).join("")
            : "<li>None</li>"
        }
      </ul>
      <h3>Production Units</h3>
      ${
        data.productionunits && data.productionunits.length > 0
          ? `<ul>${data.productionunits
              .map(
                (unit: any) => `
            <li>
              <strong>Name:</strong> ${unit.name}<br/>
              <strong>Address:</strong> ${unit.address}<br/>
              <strong>Zip Code:</strong> ${unit.zipcode}<br/>
              <strong>City:</strong> ${unit.city}<br/>
              <strong>Start Date:</strong> ${unit.startdate}<br/>
              <strong>Employees:</strong> ${unit.employees}<br/>
              <strong>Industry Code:</strong> ${unit.industrycode}<br/>
              <strong>Industry Description:</strong> ${unit.industrydesc}
            </li>
          `
              )
              .join("")}</ul>`
          : "<ul><li>None</li></ul>"
      }
    </div>
  `;
};

export const formatDetailedCVRdata = (data: any) => {
  const generateHtml = (obj: any, indent = 0): string => {
    const indentation = "  ".repeat(indent);
    if (Array.isArray(obj)) {
      if (obj.length === 0) return "";
      return obj.map((item) => generateHtml(item, indent)).join("\n");
    } else if (typeof obj === "object" && obj !== null) {
      return Object.entries(obj)
        .map(([key, value]) => {
          if (typeof value === "object" && value !== null) {
            return `${indentation}<div class="cvr-field"><strong>${key}</strong>:<div class="cvr-nested">${generateHtml(
              value,
              indent + 1
            )}</div></div>`;
          } else {
            return `${indentation}<div class="cvr-field"><strong>${key}</strong>: ${value}</div>`;
          }
        })
        .join("\n");
    } else {
      return `${indentation}<div class="cvr-value">${obj}</div>`;
    }
  };

  return `
${generateHtml(data)}
  `;
};

const formatSummarizedCVRdata = (data: any) => {
  const generateHtml = (data: any[]) => {
    return `
      <div class="company-list">
        <h2>Company List</h2>
        ${data
          .map(
            (item) => `
              <div class="company-item">
                <h3>${item.virksomhedsnavn?.vaerdi || "Unknown Company"}</h3>
                <ul>
                  <li><strong>CVR Number:</strong> ${item.CVRNummer}</li>
                  <li><strong>Start Date:</strong> ${
                    item.virksomhedStartdato
                  }</li>
                  <li><strong>Name Effective From:</strong> ${
                    item.virksomhedsnavn?.virkningFra
                  }</li>
                </ul>
              </div>
            `
          )
          .join("")}
      </div>
    `;
  };

  return `
    <div>
      ${generateHtml(data)}
    </div>
  `;
};

export const xxxgetCompanyDataByCVR = async (criteria: string) => {
  try {
    if (criteria.trim()) {
      const apiUrl =
        "https://s5-certservices.datafordeler.dk/CVR/HentCVRData/1/rest/hentVirksomhedMedCVRNummer?pCVRNummer=" +
        criteria;
      const res = await axios.get("http://localhost:3001/api/data", {
        // Updated URL
        params: { apiUrl },
      });
      //console.log("Response from CVR API:", res.data);
      const result = res.data;
      if (
        result &&
        res.data.virksomhed !== null &&
        Object.keys(res.data.virksomhed).length > 0
      ) {
        console.info("Response from CVR API:", result); //
        return result;
      } else {
        //console.warn("No valid virksomhed data found.");
        return null;
      }
    } else {
      return null;
    }
  } catch (error) {
    return "Hent virksomhedsdata fejl: " + (error as Error).message;
  } finally {
  }
};

export const getCompanyDataByCVR = async (criteria: string) => {
  try {
    if (criteria.trim()) {
      const registerUrl =
        "https://s5-certservices.datafordeler.dk/CVR/HentCVRData/1/rest/hentVirksomhedMedCVRNummer?pCVRNummer=" +
        criteria;
      const res = await axios.get(firebaseFunctionsUrl("register"), {
        params: { apiUrl: registerUrl },
      });
      const result = res.data;

      if (
        result &&
        res.data.virksomhed !== null &&
        Object.keys(res.data.virksomhed).length > 0
      ) {
        console.info("Response from CVR API:", result); //
        return result;
      } else {
        //console.warn("No valid virksomhed data found.");
        return null;
      }
    } else {
      return null;
    }
  } catch (error) {
    return "Hent virksomhedsdata fejl: " + (error as Error).message;
  } finally {
  }
};

export const getCompanyDataByName = async (criteria: string) => {
  try {
    if (criteria.trim()) {
      const registerUrl =
        "https://s5-certservices.datafordeler.dk/CVR/SoegCVRData/1/rest/soegVirksomhedMedNavn?pNavn=" +
        encodeURIComponent(criteria);
      const res = await axios.get(firebaseFunctionsUrl("register"), {
        params: { apiUrl: registerUrl },
      });
      return res.data;
    } else {
      return {};
    }
  } catch (error) {
    return "Hent virksomhedsdata fejl: " + (error as Error).message;
  } finally {
  }
};
